import React, { useState, useEffect, useContext } from "react";
import "./find-out-more.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import { findRel } from "../../../shared/utils/stringUtilities";
import LayoutContext from "../../../contexts/layoutContext";
import { GatsbyImage } from "gatsby-plugin-image";

const FindOutMore = (props: ReferenciaContenido) => {
  const {
    tituloGeneral,
    referenciaPlantillaContenido,
    tituloBoton,
    nombreCategoria,
  } = props;
  const context = useContext(LayoutContext);
  const [indexService, setindexService] = useState<any>(0);
  // console.log(context);
  const component = (dots) => {
    return (
      <div style={{ bottom: "0px" }}>
        <ul> {dots} </ul>
      </div>
    );
  };
  //console.log(props);

  const setting = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: referenciaPlantillaContenido.length > 2 ? 2.1 : 2,
    slidesToScroll: 0.7,
    initialSlide: 0,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          variableWidth: false,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          variableWidth: false,
          dots: true,
        },
      },
      {
        breakpoint: 560,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          variableWidth: false,
          dots: true,
        },
      },
      {
        breakpoint: 440,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          variableWidth: false,
          appendDots: (dots) => component(dots),
        },
      },
    ],
  };
  const [slider, setSlider] = useState<any>();
  const previous = () => {
    slider.slickPrev();
  };
  const next = () => {
    slider.slickNext();
  };
  const isHttp = (url?: string) => {
    return url?.startsWith("http");
  };

  useEffect(() => {
    if (context.slideServices?.get)
      setindexService(context.slideServices?.get - 1);
  }, [context.slideServices?.get]);
  return (
    <>
      {(!props.autoresArticulo || indexService == props.autoresArticulo[0]) && (
        <div
          className={`m-find-out ${
            tituloGeneral ? "" : "margin-biblioteca-top"
          } ${
            referenciaPlantillaContenido.length > 2 ? "" : "biblioteca-interna"
          } ${nombreCategoria === "Grupos de apoyo" ? "margin-none" : ""} `}
        >
          <div
            className={`m-find-out-header ${
              tituloGeneral ? "" : "margin-biblioteca"
            }`}
          >
            <h2
              className={`${
                tituloGeneral
                  ? "m-find-out-header-title"
                  : "m-find-out-header-subtitle"
              }`}
            >
              {tituloGeneral ? tituloGeneral : tituloBoton}
            </h2>
          </div>
          <div
            className={`m-find-out-container ${"inicial-find "} ${
              tituloGeneral ? "" : "margin-biblioteca"
            } `}
          >
            <Slider
              {...setting}
              ref={(c) => {
                setSlider(c);
              }}
            >
              {referenciaPlantillaContenido.map((val, key) => {
                return (
                  <div key={key}>
                    {val.descripcion ? (
                      <div>
                        <a
                          className={`${
                            nombreCategoria === "Servicios"
                              ? ""
                              : `gtmRedDeAmorHabitosSaludMentalInternaEnterateMas${normalizeTwoWords(
                                  val.tituloBanner
                                )}`
                          }`}
                          href={val.redireccionBoton}
                          target={
                            isHttp(val.redireccionBoton) ? "_blank" : "_self"
                          }
                          rel={findRel(val.redireccionBoton)}
                        >
                          <div
                            className={`m-find-out-card   ${
                              nombreCategoria === "Servicios"
                                ? ""
                                : `gtmRedDeAmorHabitosSaludMentalInternaEnterateMas${normalizeTwoWords(
                                    val.tituloBanner
                                  )}`
                            }`}
                          >
                            <GatsbyImage
                              className={`m-find-out-card-img ${
                                val.imagenPrincipal ? "" : "hide-pan"
                              }   ${
                                nombreCategoria === "Servicios"
                                  ? ""
                                  : `gtmRedDeAmorHabitosSaludMentalInternaEnterateMas${normalizeTwoWords(
                                      val.tituloBanner
                                    )}`
                              }`}
                              src={
                                val.imagenPrincipal
                                  ? val.imagenPrincipal[0].gatsbyImageData
                                    ? val.imagenPrincipal[0].gatsbyImageData
                                    : ""
                                  : ""
                              }
                              alt="imagen-encuentra-mas"
                            />

                            <div
                              className={`m-find-out-card-dark  ${
                                nombreCategoria === "Servicios"
                                  ? ""
                                  : `gtmRedDeAmorHabitosSaludMentalInternaEnterateMas${normalizeTwoWords(
                                      val.tituloBanner
                                    )}`
                              }`}
                            ></div>
                            <p
                              className={`m-find-out-card-pan ${
                                val.tipoTitulo ? "" : "hide-pan"
                              }  ${
                                nombreCategoria === "Servicios"
                                  ? ""
                                  : `gtmRedDeAmorHabitosSaludMentalInternaEnterateMas${normalizeTwoWords(
                                      val.tituloBanner
                                    )}`
                              }`}
                            >
                              {val.tipoTitulo}{" "}
                            </p>
                            <div
                              className={`m-find-out-card-texting  ${
                                nombreCategoria === "Servicios"
                                  ? ""
                                  : `gtmRedDeAmorHabitosSaludMentalInternaEnterateMas${normalizeTwoWords(
                                      val.tituloBanner
                                    )}`
                              }`}
                            >
                              <h3 className="m-find-out-card-title">
                                {val.tituloBanner}
                              </h3>
                              <p className="m-find-out-card-body">
                                {
                                  JSON.parse(val.descripcion.raw)?.content[0]
                                    ?.content[0]?.value
                                }
                              </p>
                            </div>
                            <div
                              className={`m-find-out-mini-card ${
                                val.tituloDescripcion ? "" : "hide-pan"
                              }   ${
                                nombreCategoria === "Servicios"
                                  ? ""
                                  : `gtmRedDeAmorHabitosSaludMentalInternaEnterateMas${normalizeTwoWords(
                                      val.tituloBanner
                                    )}`
                              }`}
                            >
                              <p>{val.tituloDescripcion} </p>
                            </div>
                          </div>
                        </a>
                      </div>
                    ) : (
                      <div>
                        <div
                          className={`m-find-out-card-video ${
                            nombreCategoria === "Biblioteca"
                              ? `gtmRedDeAmorReviveConsultoriosVirtuales${nombreCategoria}`
                              : ""
                          }`}
                        >
                          <div
                            className={`m-find-out-card-video__effect__left `}
                          ></div>
                          <iframe
                            className={`video gtmRedDeAmorReviveConsultoriosVirtualesVideo${key}`}
                            src={val.redireccionBoton}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          ></iframe>
                          <div
                            className={`m-find-out-card-video__effect__right `}
                          ></div>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </Slider>
          </div>
          <div
            className={`a-cover-icons-find-out hide-on-mobile ${
              referenciaPlantillaContenido.length > 2 ? "shown" : "hiden"
            }`}
          >
            <button className="a-icon-arrow" onClick={previous}>
              <div className="imagenLeft" />
            </button>
            <button className="a-icon-arrow" onClick={next}>
              <div className="imagenRigth" />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default FindOutMore;
